import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { RevealText, FadeUp } from "@/components/site/Reveal";

const Services = () => {
  const { t, lang } = useLang();
  return (
    <div data-testid="services-page" className="pt-28 md:pt-36 pb-24 md:pb-40">
      <section className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="text-[11px] uppercase tracking-[0.32em] text-white/50 mb-6">{t.services.eyebrow}</div>
        <RevealText lines={[t.services.title]} as="h1" className={`display text-white ${lang === "ur" ? "text-lg sm:text-xl md:text-2xl lg:text-3xl" : lang === "en" ? "text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05]" : "text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.92]"}`} />
        <FadeUp delay={0.2}>
          <p className={`mt-10 text-white/70 max-w-3xl leading-relaxed ${lang === "ur" ? "text-base" : "text-lg md:text-xl"}`}>{t.services.body}</p>
        </FadeUp>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 md:px-10 mt-20 md:mt-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {t.services.cards.map((c, i) => (
            <FadeUp key={i} delay={i * 0.06}>
              <Link to={c.to} data-testid={`services-card-${i}`} className="sw-card rounded-md p-8 md:p-10 block group relative min-h-[280px]">
                <div className="chapter-num text-4xl md:text-5xl leading-none">0{i + 1}</div>
                <div className="mt-14 space-y-3">
                  <div className="display text-2xl md:text-3xl text-white group-hover:text-[color:var(--sw-orange)] transition-colors">{c.t}</div>
                  <div className="text-white/60 text-sm leading-relaxed">{c.d}</div>
                </div>
                <ArrowUpRight className="absolute top-8 end-8 text-white/40 group-hover:text-[color:var(--sw-orange)] group-hover:rotate-45 transition-transform" size={20} />
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
